import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.br{height:44px;}.ssr-plugin'
import '.fg{gap:6px;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import '.c0{padding-left:12px;}.ssr-plugin'
import { styled } from 'inlines'
import { radius } from '../../utils/radius.js'
import { IconButton } from '../IconButton/index.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { Loader } from '../Loader/index.js'

const shortenTheString = (str: string) => {
  return str.length > 27
    ? str.substring(0, 10) + '...' + str.substring(str.length - 10)
    : str
}

type InlineFilePreviewItemProps = {
  fileName: string
  progress: number
  cancelUpload: (fileName: string) => void
}

export const InlineFilePreviewItem = ({
  fileName,
  progress,
  cancelUpload,
}: InlineFilePreviewItemProps) => {
  return (
    <styled.div className="a d br fg fj c0"
      style={{
        borderRadius: radius[12],
        '&:hover': {
          background: colors.neutral10,
          '& :nth-child(5)': {
            opacity: 1,
            pointerEvents: 'auto',
          },
        },
        '& :nth-child(5)': {
          opacity: 0,
          pointerEvents: 'none',
        },
      }}
    >
      <Loader value={progress} />
      <Text color="neutral80" variant="display-medium">
        {shortenTheString(fileName)}
      </Text>
      <div
        style={{
          width: 2,
          height: 2,
          borderRadius: '50%',
          marginRight: 4,
          marginLeft: 4,
          background: colors.neutral60,
        }}
      />
      <Text color="neutral60" variant="display-regular">
        {progress === 100 ? 'done' : progress + '%'}
      </Text>
      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <IconButton
          icon="close"
          size="small"
          onClick={() => cancelUpload(fileName)}
        />
      </div>
    </styled.div>
  )
}
